// extracted by mini-css-extract-plugin
export default {"root":"conservation_root__zGFkP"};